<template>
  <div style="height: 100%;">
    <div>
      <Header />
      <div class="main-wrapper width1200 plolicy-top-box">
        <div class="search-box">
          <!-- <select>
            <option>北京</option>
            <option>上海</option>
            <option>深圳</option>
          </select> -->
          <div class="search-input-box">
            <input type="type" placeholder="请输入搜索内容" name="" v-model="searchkey">
            <button @click="cliSearch">搜索</button>
          </div>
        </div>

        <div class="policy-main">
          <div class="policy-top-tab">
            <!-- tab nav -->
            <ViewTabList />
            <!-- tab nav -->

            <SearchCondition @activeItem="onActiveItem" @onselected="onConditionSelected" :items="initSearchCondition"
              :selectedKeys="selectedKeys" />
          </div>

          <div class="main-container">
            <!-- 筛查条件pc -->
            <div class="screening-box main-container-left">
              <div class="screen-items">
                <div class="right-text">
                  <div style="width: 150px;">
                    <p>专业领域 ：</p>
                  </div>
                  <div>
                    <a href="javascript:;" :class="selcategory==index?'active':''" v-for="(item,index) in category"
                      @click.prevent="selCategory(index)">{{item}}</a>
                  </div>
                </div>
              </div>
              <!-- <div class="screen-items">
                <p>学历 ：</p>
                <div class="right-text">
                  <a href="javascript:;" class="active">全部</a>
                  <a href="javascript:;">专科</a>
                  <a href="javascript:;">本科</a>
                  <a href="javascript:;">硕士研究生</a>
                  <a href="javascript:;">博士研究生</a>
                </div>
              </div> -->
              <div class="screen-items">
                <div class="right-text height-auto">
                  <p>职称 ：</p>
                  <a href="javascript:;" :class="selgrades==index?'active':''" v-for="(item,index) in grades"
                    @click.prevent="selGrades(index)">{{item}}</a>
                </div>
              </div>
            </div>
            <!-- 筛查条件pc -->
            <div class="main-container-right main-container-right-pc">
              <!-- 政策列表 -->
              <div class="policy-list special-list-container">
                <div @click="findSpeciallist" class="consulting">聘 专 家</div>
                <ul class="special-list" v-if="!hidelist">
                  <li class="special-list-item" v-for="(item,index) in resaultlist" :key="index" @click="openDetail(item.sid)">
                    <div class="top">
                      <div class="left">
                        <img :src="item.head_img">
                      </div>

                      <div class="right">
                        <p class="name special-name">{{item.name}}</p>
                        <div class="min-line">
                          <p class="special-org">单位:{{item.organization}}</p>
                        </div>
                        <div class="min-line">
                          <p>职称:{{item.grade}}</p>
                        </div>
                        <div>
                           <p class="special-point">亮点:{{item.signature}}</p>
                        </div>
                      </div>
                    </div>
                    <div class="bottom">
                      <div class="left">新基建领域：</div>
                      <div class="right">{{item.industry_category}}</div>
                    </div>
                  </li>

                </ul>
              </div>
              <div class="paging-box">
                <el-pagination layout="prev, pager, next" :page-size="limit" :total="count" @current-change="pagechange"></el-pagination>
              </div>
              <!-- 政策列表 -->
            </div>
          </div>


        </div>

      </div>
      <Footer :isLogin="true" />
    </div>
  </div>
</template>

<script>
  import Header from '@/components/Header.vue';
  import Footer from '@/components/Footer.vue';
  import ViewTabList from '@/components/ViewTabList.vue';
  import SearchCondition from '@/components/SearchCondition.vue';
  import {
    SpecialistSearchCondition
  } from '@/const/SpecialistSearchCondition.js'
  import SearchConditionMixin from '@/mixins/SearchCondition.mixin.js'
  import {
    Pagination
  } from 'element-ui';
  import {
    addSpecialist,
    modifySpecialist,
    getSpecialist,
    searchspecialist
  } from '@/api/specialist.js'
  import config from '@/config/index';

  export default {
    mixins: [SearchConditionMixin],
    name: 'VSpecialist',
    components: {
      Header,
      Footer,
      ViewTabList,
      [Pagination.name]: Pagination,
      SearchCondition,
    },
    watch: {
      $route(to, from) {}
    },
    data() {
      return {
        hidelist:false,
        initSearchCondition: SpecialistSearchCondition,
        resaultlist: [],
        page: 1,
        limit: 12,
        count: 0,
        searchkey: '',
        grade: '',
        industrycategory: '',
        grades: ['全部', '正高', '副高', '中级', '中级以下', ],
        category: ['全部', '智慧应用', '数据智能', '生态系统', '可信安全', '新型网络', '科创平台', '数字上云', '金融服务'],
        selgrades: 0,
        selcategory: 0,
      }
    },
    mounted() {
      if(this.$route.query.keyword){
        this.searchkey = this.$route.query.keyword
      }
      this.querySpecialist()
    },
    methods: {
      cliSearch() {
        this.querySpecialist()
      },
      selGrades(index) {
        this.selgrades = index
        if (index == 0) {
          this.grade = ''
        } else {
          this.grade = this.grades[index]
        }
        this.querySpecialist()
      },
      selCategory(index) {
        this.selcategory = index
        if (index == 0) {
          this.industrycategory = ''
        } else {
          this.industrycategory = this.category[index]
        }
        this.querySpecialist()
      },
      findSpeciallist() {
        this.$router.push('/special-find');
      },
      pagechange(page) {
        this.page = page
        this.querySpecialist()
      },
      querySpecialist() {
        const grade = this.grade
        const industrycategory = this.industrycategory
        const page = this.page
        const limit = this.limit
        const searchkey = this.searchkey
        this.$http.get(searchspecialist(), {
          searchkey,
          grade,
          industrycategory,
          page,
          limit
        }).then(res => {
          console.log(res);
          if (res.code === 1) {
            // this.$router.push('org');
            this.resaultlist = []
            this.count = res.data.count
            var list = res.data.list
            var item;
            for (var i = 0; i < list.length; i++) {
              item = list[i]
              var img = item.head_img
              item.head_img = `${config.HOST_IMG}${img}`
              this.resaultlist.push(item)
            }
          } else {
            this.$message.warning(res.msg);
          }
        });
      },
      openDetail(sid) {
        this.$router.push('/specialist-detail?sid=' + sid)
      },
      toogleListShow(hide) {
        this.hidelist = hide
        if (hide == false) {
          this.selectedKeys.forEach(item => {
            if(item.boxKey==="领域分类"){
              if(item.item.index==0){
                this.industrycategory = ''
              }else{
                this.industrycategory =item.key
              }
            }else{
             if(item.item.index==0){
               this.grade = ''
             }else{
               this.grade =item.key
             }
            }
          })
          // console.log("this.governmenttype->",this.governmenttype)
          // console.log("this.policytype>",this.policytype)
          this.querySpecialist()
        }
      }
    }
  }
</script>

<style scoped>
  @import url(./Policy.css);

  .special-name{
    height: 30px;
  	display: -webkit-box;
  	-webkit-box-orient: vertical;
  	-webkit-line-clamp: 1;
  	overflow: hidden;
  }
.min-line{
  min-height: 30px;
}
  .special-org{
  	height: 20px;
  	display: -webkit-box;
  	-webkit-box-orient: vertical;
  	-webkit-line-clamp: 2;
  	overflow: hidden;
  }

  .paging-box {
    text-align: center;
    /* margin: 30px 0 30px 140px; */
    overflow: hidden;
  }

  .plolicy-top-box {
    width: 12rem;
    margin: 0 auto;
  }

  .policy-list {
    padding: unset;
  }
/*
  .screen-items p {
    width: auto !important;
    text-align: left !important;
  } */

  .special-list-container {
    padding: 10px 18px;
  }

  .special-list-item {
    width: 3.08rem;
    border: .01rem solid #D9D9D9;
    padding: unset;
    display: inline-block;
  }

  body.pcStyle .special-list-item {
    margin-bottom: .2rem;
    width: 2.28rem;
    border: .01rem solid #D9D9D9;
    padding: unset;
    display: inline-block;
  }

  .special-list-item:not(:nth-child(3n)) {
    margin-right: 7px;
  }

  body.pcStyle  .special-list-item:not(:nth-child(4n)) {
    margin-right: 12px;
  }

  .special-list-item .top {
    padding: .1rem;
    display: flex;
  }

  .main-container-right {
    width: 100%;
  }

  body.pcStyle .special-list-item .top {
    padding: unset;
    display: flex;
    flex-direction: column;
    text-align: center;
  }

  body.pcStyle .special-list-item .top .left img {
    width: 1.4rem;
    height: 1.4rem;
    border-radius: 50%;
  }
  .special-list-item .top .left {
    text-align: center;
    margin-top: .3rem;
    /* width: .76rem; */
    /* height: .76rem; */
    /* margin-right: .1rem; */
  }

  .special-list-item .top .right p {
    font-size: 12px;
    color: #676666;
    /* margin-top: 20px; */
  }

  .special-list-item .top .right .name {
    font-size: 20px;
    color: #267FF2;
    margin-top: .24rem;
  }

  body.pcStyle .special-list-item .top .right .right_content {
    display: flex;
    justify-content: space-around;
    overflow: hidden;
    height: 25px;
    margin-top: .2rem;
  }

  .special-list-item .bottom {
    display: flex;
    margin-top: .18rem;
  }

  .special-list-item .bottom div {
    /* display: inline-block; */
    padding: .08rem .08rem;
    color: #fff;
  }

  .special-list-item .bottom .left {
    position: relative;
    width: 1rem;
    background: linear-gradient(322deg, #FEE4DF 0%, #F76A4A 100%);
  }

  .special-list-item .bottom .left::after,
  .special-list-item .bottom .left::before {
    height: 0px;
    width: 0px;
    overflow: hidden;
    font-size: 0;
    line-height: 0;
    border-color: transparent #63A3F6 transparent transparent;
    border-style: solid solid solid solid;
    border-width: 22px 22px 0px 0px;
    position: absolute;
    content: ' ';
    top: 15px;
    right: 0;
  }

  .special-list-item .bottom .left::before {
    top: 0;
    transform: rotate(-90deg);
  }

  .special-list-item .bottom .right {
    flex: 1;
    background: linear-gradient(280deg, #B8D5FB 0%, #63A3F6 100%);
  }
  @media screen and (max-width: 850px) {
    .special-list {
      display: flex;
      flex-direction: column;
    }
    .special-list-item {
      width: 100%;
      padding: .24rem;
      box-sizing: border-box;
    }
    .special-list-item .top {
      padding: unset;
    }
    .special-list-item .top .left {
      width: .88rem;
      height: .88rem;
      border-radius: 50%;
      margin-right: .24rem;
      overflow: hidden;
    }
    .special-list-item .top .right .name {
      font-size: 32px;
      color: #333;
    }
    .special-list-item .top .right .special-point  {
      color: #999;
    }
    .special-list-item .top .right p {
      font-size: 26px;
      color: #666;
    }
    .special-list-item .bottom .left {
      display: none;
    }
    .special-list-item .bottom .right {
      background: unset;
      flex: unset;
      /* width: .96rem; */
      height: .34rem;
      border: 2px solid #267FF2;
      font-size: 24px;
      color: #267FF2;
      padding: 0 .12rem;
      margin-top: .16rem;
    }
    .special-list-item .bottom {
      padding-left: 1.12rem;
    }
  }
</style>
